import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const CheckCircleIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
    >
      <path
        opacity="0.4"
        d="M20.5206 12C20.5206 7.16165 16.5987 3.23975 11.7603 3.23975C6.9219 3.23975 3 7.16165 3 12C3 16.8384 6.9219 20.7603 11.7603 20.7603C16.5987 20.7603 20.5206 16.8384 20.5206 12Z"
        stroke="#3064C0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0009 5.40137C16.218 8.07888 13.2505 12.4055 11.8408 15.0538C10.8746 13.432 9.64972 11.9901 8.16016 10.7321"
        stroke="#3064C0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckCircleIcon;
